export const isContainedByView = (node: HTMLElement): boolean => {
  const rect = node.getBoundingClientRect();

  return rect.top >= 0 && rect.bottom <= window.innerHeight;
};

export const getDataset = (
  node: HTMLElement | EventTarget
): Record<string, unknown> => {
  if (!('dataset' in node)) {
    return {};
  }

  return node.dataset;
};

/**
 * Safely resolve `Element.closest` from an event target. An `event.target` can
 * be the Document, window, or a text node (e.g. document-level `useOutsideClick`
 * handlers), none of which expose `closest`. Returns null for non-Element
 * targets instead of throwing.
 */
export const getEventTargetClosest = (
  target: EventTarget | null,
  selector: string
): Element | null =>
  target instanceof Element ? target.closest(selector) : null;
